import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { IoCloseCircle } from 'react-icons/io5';
import { useState } from 'react';
import SnackBar from '../General/SnackBar';
import { HandleDelete } from 'API/KycUpload/api';
import BackdropLoader from '../General/Loader';

export default function DeleteConfirmDialog(props) {


    // console.log("props",props);

    const [Alert,setALert]=useState({
        open:false,
        message:"",
        type:"success"
    })
    const [IsLoading, setIsLoading] = useState(false);


    const handleAlertOpen=(message,type)=>{
        setALert({
            open:true,
            message:message,
            type:type
        })
      }

    const handleCloseDeleteAlert=()=>{
      setALert({
        open:false,
        message:"",
        type:"success"
      })
    }


    const handleDelete=()=>{
      let data={
        user_id: props.userId,
        document_key: props.field,
        document_name: props.data
      }
      // console.log("data at delete confirm dialog",data);
      HandleDelete(data,setIsLoading,handleAlertOpen,props.handleGet,props.handleClose,props.handleCloseMain)
      
    }
    
  

  return (
    <React.Fragment>
      <SnackBar open={Alert.open} message={Alert.message} type={Alert.type} handleClose={handleCloseDeleteAlert} />
      <BackdropLoader open={IsLoading} />
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
         <Box sx={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", fontSize: '24px', zIndex: 10 }} onClick={props.handleClose}>
                <IoCloseCircle />
            </Box>
        <DialogTitle id="alert-dialog-title">
          <Typography variant='h4'>Confirmation</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to proceed with deleting the file?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{display:"flex",alignItems:"center",justifyContent:"center"}}>
          <Button size='small' variant='contained' color='secondary' sx={{borderRadius:"8px"}} onClick={handleDelete} >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
